import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import SideBar from "./SideBar";
import NavHader from "./NavHader";
import Header from "./Header";
import LoadingComponent from "./loading";
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);

  const [hasFetched, setHasFetched] = useState(false);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState({});
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      axios
        .get(`${baseURL}/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          setHasFetched(true);
          localStorage.setItem('user_id', (res.data.id));
          localStorage.setItem('user_permissions', JSON.stringify(res.data.permissions));
          setPermissions(res.data.permissions);
          setLoading(false);
        })
        .catch((err) => {
          console.log("Failed to fetch user info:", err);
          localStorage.removeItem('user_id');
          localStorage.removeItem('user_permissions');
          navigate("/login");
          setLoading(false);
        });
    } else {
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_permissions');
      navigate("/login");
      setLoading(false);
    }
  }, []);

  if (!hasFetched) {
    return (
      <LoadingComponent loading={loading} />
    )
  }

  return (
    <Fragment>

      <NavHader />
      <Header
        onNotification={() => onClick("notification")}
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
      <SideBar permissions={permissions}/>
    </Fragment>
  );
};

export default JobieNav;
